import { ModalController } from '@ionic/angular';
import { Component, OnInit, ViewChild } from '@angular/core';
import { AppComponent } from '../../app.component';
import { Cookie } from '../../../../plugins/cordova-plugin-advanced-http/www/umd-tough-cookie';
import { MenuserviceService } from '../../service/menuservice.service';
import { MiCvuPage } from '../../pages/modulos/mi-cvu/mi-cvu.page';
import { UsuarioService } from '../../service/usuario.service';
import { HomePage } from '../../pages/modulos/home/home.page';
import { Input } from '@angular/core';
import { NavController } from '@ionic/angular';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  @Input() iniciales
  @Input() nuevo
  @Input() validado
  @Input() username
  @Input() muestro_menu
  modalDataResponse: any;
  mail:any
  celular:any
  nombreInicial;
  constructor(public navCtl: NavController,public modalCtrl: ModalController,public menuService: MenuserviceService,public usuarioService: UsuarioService) { }

  ngOnInit() {
    // cargar()
  }
  getIniciales(){
    if(this.nombreInicial!=null)
      return this.nombreInicial;
    this.nombreInicial=JSON.parse(localStorage.getItem("cuentas")).filter(dato=>{return dato.token==localStorage.getItem("token")})[0].iniciales;
    return this.nombreInicial;
  }
  async VerCvu() {
    const modal = await this.modalCtrl.create({
      component: MiCvuPage
    });

    modal.onDidDismiss().then((modalDataResponse) => {
      if (modalDataResponse !== null) {
        this.modalDataResponse = modalDataResponse.data;
      }
    });

    return await modal.present();
  }
  obtener_datos_usuario() {

    let nombre = localStorage.getItem("nombre");
    let iniciales = localStorage.getItem("iniciales");
    if (nombre && iniciales) {
      this.username = nombre;
      this.iniciales = iniciales;
    }
    else {
      nombre = localStorage.getItem("nombre");
      if (nombre && this.iniciales) {
        this.username = nombre;
      } else {
        this.usuarioService.obtener_mis_datos().then((data: any) => {
          this.username = data.nombre_completo;
          this.mail = data.email;
          this.celular = data.celular;
          localStorage.setItem("nombre", this.username);
          this.iniciales = data.nombre
            .charAt(0)
            .toUpperCase()
            + data.apellido
              .charAt(0)
              .toUpperCase();
          localStorage.setItem("iniciales", this.iniciales);
          localStorage.setItem("mail", this.mail);
        });
      }
    }
    let menu = Cookie.get("menu");
    AppComponent.menu = [];
    AppComponent.menu.length = 0;
    if (AppComponent.token != localStorage.getItem("token") || !menu || menu.length == 0) {
      Cookie.delete("menu");
      this.menuService.obtener_menu().then((data: []) => {
        AppComponent.menu = [];
        data.forEach(element => {
          AppComponent.menu.push(element);
        });
        AppComponent.token = localStorage.getItem("token");
        Cookie.set("menu", JSON.stringify(AppComponent.menu), AppComponent.DIAS);
      })
    }
    else {
      let data = JSON.parse(menu);
      for (var i in data) {
        AppComponent.menu.push(data[i]);
      }
      Cookie.set("menu", JSON.stringify(AppComponent.menu), AppComponent.DIAS);
    }
  }

  cantidad_cuentas() {
    return localStorage.getItem("cuentas").length;
  }
  VerNotificaciones() {
    this.navCtl.navigateForward("notificaciones");
  }
  // cargar() {
    // this.iniciales = HomePage.getIniciales()
  // }
}
